import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

export type UploadPhase = "preparing" | "uploading" | "saving";

interface Props {
  phase: UploadPhase;
  /** 0-100; only used while `phase` is "uploading". */
  progress: number;
}

/** Inline upload progress shown above the action buttons of both upload forms. */
const UploadProgress = ({ phase, progress }: Props) => (
  <Box sx={{ mt: 3 }}>
    <Typography variant="caption" color="textSecondary">
      {phase === "preparing"
        ? "Preparing upload…"
        : phase === "saving"
          ? "Finishing up…"
          : `Uploading… ${progress}%`}
    </Typography>
    <LinearProgress
      variant={phase === "uploading" ? "determinate" : "indeterminate"}
      value={progress}
      sx={{ borderRadius: 1, mt: 0.5 }}
    />
  </Box>
);

export default UploadProgress;
